export default "__VITE_ASSET__C2zNe2Fy__"